import { slickDefaults } from '@/utils/carousel';

class HomeReviews {
  constructor() {
    this.$el = $('.home-reviews');

    this.ui = {
      $items: $('.home-reviews__items', this.$el),
    };

    this.createCarousel();
  }

  createCarousel() {
    const $controls = $('<div class="slick-controls mr-auto d-none d-xl-flex" />');

    this.ui.$items
      .append($controls)
      .slick(slickDefaults({
        slidesToShow: 2,
        slide: '.home-reviews__item',
        appendArrows: $controls,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 1,
            }
          }
        ]
      }));
  }
}

export default HomeReviews;
